var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var UserController = {
    /*****************************************************************************************************
        * Is using route "api/user/list/{userid}/groups" and http method "GET" to call the back-end.
    
        * @param {string} userid
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    GetUserListForAllGroups: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{userid}/groups", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/search" and http method "POST" to call the back-end.
    
        * @param {UserSearchDto} searchInfo
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    SearchUsers: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.searchInfo
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/list/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    GetUserListForGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/onetimetoken" and http method "GET" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    GetOneTimeToken: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/onetimetoken", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/list/{groupid}/excel" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @returns {LinkDto}
    ******************************************************************************************************/
    CreateUserListExcel: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/list/all/excel" and http method "POST" to call the back-end.
    
        * @returns {LinkDto}
    ******************************************************************************************************/
    CreateUserListExcelForAllGroups: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/all/excel", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/list/{groupid}/excel/{userid}/{token}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @param {string} userid
        * @param {string} token
        * @returns {string}
    ******************************************************************************************************/
    GetUserListForGroupAsExcel: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/list/{groupid}/excel/{userid}/{token}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/settings" and http method "GET" to call the back-end.
    
        * @returns {UserSettingsDownloadDto}
    ******************************************************************************************************/
    GetUserSettings: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/settings", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/info" and http method "GET" to call the back-end.
    
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    GetUserInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/info/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    GetUserInfoByUserId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/competencies/{id?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ExtendedDataCollection<CompetenceDownloadDto, Record<string, ItemCompetencesDownloadDto>>}
    ******************************************************************************************************/
    GetUserCompetences: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/competencies/{id?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/competencies/{id?}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ItemCompetencesUploadDto} upload
        * @returns {void}
    ******************************************************************************************************/
    UpdateUserCompetences: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("upload", JSON.stringify(data.upload));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/competencies/{id?}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/info" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    GetUserInfoByUserIds: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/info/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {UserUploadDto} userInfo
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    PostUserInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/info/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userInfo
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/avatar/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {File} mediaData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    PostAvatar: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaData)
            fd.append("mediaData", data.mediaData);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/avatar/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/settings/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {UserSettingsUploadDto} settings
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    PostUserSettings: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/settings/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.settings
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/stats/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserStats}
    ******************************************************************************************************/
    GetUserStats: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/stats/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/UserVisitedGroupEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {UserVisitedGroupEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    AddUserVisitedGroupEvent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/UserVisitedGroupEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/UserSeenEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {UserSeenEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    AddUserSeenEvent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/UserSeenEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/event/{name}/ChatEvent" and http method "POST" to call the back-end.
    
        * @param {string} name
        * @param {ChatEventUploadDto} eventData
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    AddChatEvent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/event/{name}/ChatEvent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.eventData
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/profile/{id?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {UserProfileDownloadDto}
    ******************************************************************************************************/
    GetProfile: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/profile/{id?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/profile/{id?}" and http method "PATCH" to call the back-end.
    
        * @param {UserProfileUploadDto} profile
        * @param {File} image
        * @param {string} id
        * @returns {UserProfileDownloadDto}
    ******************************************************************************************************/
    PatchProfile: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("profile", JSON.stringify(data.profile));
        if (data.image)
            fd.append("image", data.image);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/profile/{id?}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/{groupid}/{role}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {string} role
        * @param {UserUploadDto} user
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    Post: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{groupid}/{role}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.user
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/easy/register/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {EasyRegisterDto} data
        * @returns {string}
    ******************************************************************************************************/
    EasyRegister: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/easy/register/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/easy/join/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    EasyJoin: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/easy/join/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/{userId}/lock" and http method "POST" to call the back-end.
    Sets the locked status for a user.
    
        * @param {string} userId  The id of the user
        * @param {boolean} locked  The locked status
        * @returns {void}
    ******************************************************************************************************/
    SetUserLocked: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{userId}/lock", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.locked
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/useradmin" and http method "GET" to call the back-end.
    Returns a list of user admins of the user except global admins.
    
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    GetUserAdmins: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/useradmin", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/excel/check/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {File} excelFile
        * @returns {ImportCheckResult<UserImportInfo>}
    ******************************************************************************************************/
    CheckExcelInvite: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/excel/check/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/excel/invite/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {OptionalTime} time
        * @param {File} excelFile
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    ExcelInvite: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("time", JSON.stringify(data.time));
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/excel/invite/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/newRandomPassword/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    SetNewRandomPassword: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/newRandomPassword/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/requestRegister" and http method "POST" to call the back-end.
    
        * @param {RegisterRequestUploadDto} registerRequest
        * @returns {void}
    ******************************************************************************************************/
    RequestRegister: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/requestRegister", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.registerRequest
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/confirmRegisterRequest/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    ConfirmRegisterRequest: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/confirmRegisterRequest/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/approveRegisterRequest/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    ApproveRegisterRequest: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/approveRegisterRequest/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/user/setPasswordFromRegisterRequest/{id}/{change}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} change
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    SetPasswordFromRegisterRequest: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/setPasswordFromRegisterRequest/{id}/{change}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/{groupId}/registerRequest" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {RegisterRequestDownloadDto[]}
    ******************************************************************************************************/
    GetRegisterRequests: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/{groupId}/registerRequest", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/registerRequest/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteRegisterRequest: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/registerRequest/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/device/register" and http method "POST" to call the back-end.
    
        * @param {ApplicationType} applicationType
        * @param {DeviceType} deviceType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    RegisterDevice: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("deviceType", JSON.stringify(data.deviceType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/push/publickey" and http method "GET" to call the back-end.
    
        * @returns {PublicKeyDownloadDto}
    ******************************************************************************************************/
    GetPublicKey: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/push/publickey", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/push/register" and http method "POST" to call the back-end.
    
        * @param {string} publicKeyId
        * @param {PushData} pushData
        * @param {ApplicationType} applicationType
        * @returns {void}
    ******************************************************************************************************/
    PostPush: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("publicKeyId", JSON.stringify(data.publicKeyId));
        fd.append("pushData", JSON.stringify(data.pushData));
        fd.append("applicationType", JSON.stringify(data.applicationType));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/push/register", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/device/unregister" and http method "POST" to call the back-end.
    
        * @param {ApplicationType} applicationType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    UnRegisterDevice: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/unregister", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/device/background" and http method "POST" to call the back-end.
    
        * @param {boolean} inBackground
        * @param {ApplicationType} applicationType
        * @param {string} tag
        * @returns {void}
    ******************************************************************************************************/
    SetDeviceIsInBackground: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("inBackground", JSON.stringify(data.inBackground));
        fd.append("applicationType", JSON.stringify(data.applicationType));
        fd.append("tag", JSON.stringify(data.tag));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/device/background", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/checkAndAutoAddGroups" and http method "POST" to call the back-end.
    
        * @param {RegisterRequestConditionDto} condition
        * @returns {RegisterRequestResultDto}
    ******************************************************************************************************/
    CheckAndAutoAddGroups: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/checkAndAutoAddGroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.condition
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/upsertElementLastViewed/{groupId}/{element}/{time?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} element
        * @param {number | null} time
        * @returns {void}
    ******************************************************************************************************/
    UpsertElementLastViewed: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/upsertElementLastViewed/{groupId}/{element}/{time?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/upsertElementLastViewedByGroupType/{groupType}/{element}/{time?}" and http method "POST" to call the back-end.
    
        * @param {string} groupType
        * @param {string} element
        * @param {number | null} time
        * @returns {void}
    ******************************************************************************************************/
    UpsertElementLastViewedByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/upsertElementLastViewedByGroupType/{groupType}/{element}/{time?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/getElementsLastViewed/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ElementLastViewedDownloadDto[]}
    ******************************************************************************************************/
    GetElementsLastViewed: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/getElementsLastViewed/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/getElementsLastViewedByGroupType/{groupType}" and http method "GET" to call the back-end.
    
        * @param {string} groupType
        * @returns {ElementLastViewedDownloadDto[]}
    ******************************************************************************************************/
    GetElementsLastViewedByGroupType: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/getElementsLastViewedByGroupType/{groupType}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/deactivate/{userId}" and http method "GET" to call the back-end.
    
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    DeactivateUser: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/deactivate/{userId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/emailNotification/{id}/{active}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} active
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    SetUserEmailNotificationForId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/emailNotification/{id}/{active}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/pushNotification/{id}/{active}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} active
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    SetUserPushNotificationForId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/pushNotification/{id}/{active}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/taskCreation/{id}/{active}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {boolean} active
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    SetUserTaskCreationForId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/taskCreation/{id}/{active}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/removeOtpSecret/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    RemoveOtpSecret: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/removeOtpSecret/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/checkPpn" and http method "POST" to call the back-end.
    
        * @param {PpnUserInfo} userInfo
        * @returns {PPNUserCheckResult}
    ******************************************************************************************************/
    CheckPpn: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/checkPpn", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.userInfo
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/createUser" and http method "POST" to call the back-end.
    
        * @param {UserUploadDto} userData
        * @param {string} password
        * @param {GroupRolesUploadDto[]} groupRoles
        * @returns {UserDownloadDto}
    ******************************************************************************************************/
    CreateUser: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("userData", JSON.stringify(data.userData));
        fd.append("password", JSON.stringify(data.password));
        fd.append("groupRoles", JSON.stringify(data.groupRoles));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/createUser", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/mergeWith/{currentUserId}/{toMergeWithUserId}" and http method "POST" to call the back-end.
    
        * @param {string} currentUserId
        * @param {string} toMergeWithUserId
        * @param {UserMergeConfig} config
        * @returns {void}
    ******************************************************************************************************/
    MergeUserWith: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("config", JSON.stringify(data.config));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/mergeWith/{currentUserId}/{toMergeWithUserId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/mergeWith/{currentUserId}/{toMergeWithUserId}/undo" and http method "POST" to call the back-end.
    
        * @param {string} currentUserId
        * @param {string} toMergeWithUserId
        * @returns {void}
    ******************************************************************************************************/
    UndoMergeUserWith: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/mergeWith/{currentUserId}/{toMergeWithUserId}/undo", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/mergeWith/{currentUserId}" and http method "GET" to call the back-end.
    
        * @param {string} currentUserId
        * @returns {ExtendedDataCollection<UserDownloadDto, UserMergeLogDownloadDto[]>}
    ******************************************************************************************************/
    GetMergeUserWith: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/mergeWith/{currentUserId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/certificates/{userId?}" and http method "GET" to call the back-end.
    
        * @param {string} userId
        * @returns {ExtendedDataCollection<LearnerCertificateDownloadDto, UserCertificates>}
    ******************************************************************************************************/
    GetUserCertificates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/certificates/{userId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/user/certificates/{certId}/{userId}" and http method "POST" to call the back-end.
    
        * @param {string} certId
        * @param {string} userId
        * @returns {void}
    ******************************************************************************************************/
    AssignCertificateToUser: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/user/certificates/{certId}/{userId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=UserController.js.map